import { defineStore, acceptHMRUpdate } from 'pinia';
import useUiPlanningStore from '@/stores/ui/planning';
import useUiSavingStore from '@/stores/ui/saving';
import useEventbusStore from '@/stores/eventbus';
import usePlanningSubprojectsStore from '@/stores/subprojects';
import usePlanningTimelineStore from './timeline';
import usePlanningConfigStore from './config';
import usePlanningElementsStore from './elements';

const store = defineStore('planning', {
  state: () => ({
    planning: {},
  }),

  getters: {
    hasSubprojects() {
      return this.planning.lanes?.find(item => item.project_id) && true || false;
    },
  },

  actions: {
    set({ planning }) {
      this.planning = planning;
      usePlanningTimelineStore().set(planning.timeline);
      usePlanningConfigStore().init(planning.config);
      setTimeout(() => { // init all calculations in a single batch on startup to avoid components individual recalcultation
        planning.elements.forEach((el) => {
          el.updateHeight();
        });
      });
    },
    save() {
      const { planning } = this;
      const uiPlanningStore = useUiPlanningStore();
      const uiSavingStore = useUiSavingStore();
      const isView = uiPlanningStore.view;
      const isDynamic = uiPlanningStore.dynamic;
      if (! isView && ! isDynamic) return;

      if (uiSavingStore.inprogress) {
        uiSavingStore.saveagain = true;
        return;
      }
      uiSavingStore.start();

      if (isView) {
        setTimeout(async () => { // wait for new elements creation
          const { default: vueApp } = await import('@/js/vueApp');
          const viewId = vueApp?.config.globalProperties.$route.params.id;
          planning.saveView(viewId).then((hasSavedContent) => {
            uiSavingStore.setSuccess();
            if (uiSavingStore.saveagain) {
              setTimeout(() => this.save(), 300);
              return;
            }
            // Send notification
            if (hasSavedContent) window.notificationsSrv.callEvent('projectSaved', { planning_id: planning.id, planning_title: planning.getTitle() });
          }).catch((message) => {
            uiSavingStore.setError(message);
            if (uiSavingStore.saveagain) {
              setTimeout(() => this.save(), 300);
            } else {
              useEventbusStore().call({ event: 'update-project' }); // update project to resolve saving conflicts
            }
          });
        });
      } else if (isDynamic) {
        planning.save().then((contentPatch) => {
          uiSavingStore.setSuccess();
          // Send notification
          if (contentPatch) window.notificationsSrv.callEvent('projectSaved', { contentPatch, planning_id: planning.id, planning_title: planning.getTitle() });
          if (uiSavingStore.saveagain) setTimeout(() => this.save(), 300);
        }).catch((message) => {
          uiSavingStore.setError(message);
          if (uiSavingStore.saveagain) {
            setTimeout(() => this.save(), 300);
          } else {
            useEventbusStore().call({ event: 'update-project' }); // update project to resolve saving conflicts
          }
        });
      }
    },
    changeTimeline(oldTimeline) {
      usePlanningElementsStore().onChangeTimeline(oldTimeline);
      usePlanningSubprojectsStore().onChangeTimeline();
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
